import { Component, Input } from '@angular/core';
import { Store } from 'src/app/core/stores.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-store-details-general-info',
  templateUrl: './store-details-general-info.component.html',
  styleUrls: ['./store-details-general-info.component.scss'],
})
export class StoreDetailsGeneralInfoComponent {
  @Input() store?: Store;

  constructor(private utils_service: UtilsService) {}

  getStoreStatusBackgroundClass(): { [key: string]: boolean | undefined } {
    if (!this.store) return {};
    return this.utils_service.getStoreStatusBackgroundClass(this.store);
  }

  getStoreStatusLabel(): string {
    if (!this.store) return '';
    return this.utils_service.getStoreStatusLabel(this.store);
  }

  getStoreName(): string {
    if (!this.store?.name) {
      return '-';
    }

    if (this.store.name.length > 30) {
      return this.store.name.slice(0, 27) + '...';
    }

    return this.store.name;
  }

  getCompanyName(): string {
    if (!this.store?.company_business_name) {
      return '-';
    }

    if (this.store.company_business_name.length > 30) {
      return this.store.company_business_name.slice(0, 27) + '...';
    }

    return this.store.company_business_name;
  }

  getFormattedPhone(): string {
    if (!this.store?.phone) {
      return '-';
    }

    return this.store.phone.prefix + ' ' + this.store.phone.value;
  }

  getFormattedAddress(): string {
    if (!this.store?.address) {
      return '-';
    }

    return this.store.address.line1 + ' (' + this.store.address.city + '), ' + this.store.address.country;
  }
}
